"use client";

import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/utils";

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-[1.15rem] w-10 shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:ring-[3px]",
        "data-[state=checked]:bg-[#379A2A] data-[state=unchecked]:bg-[#EFEFEF]",
        "dark:data-[state=unchecked]:bg-input/80",
        "focus-visible:border-ring focus-visible:ring-ring/50",
        "disabled:bg-gray-300 disabled:data-[state=checked]:bg-[#A5D6A7] disabled:data-[state=unchecked]:bg-[#E0E0E0]",
        "disabled:cursor-not-allowed disabled:opacity-70",
        "shadow-inner",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-white block size-3.5 rounded-full ring-0 transition-transform",
          "data-[state=checked]:translate-x-5.5 data-[state=unchecked]:translate-x-0.5",
          "disabled:bg-gray-100"
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
